import { Directive, ElementRef, Renderer2, HostListener, Inject, DOCUMENT } from '@angular/core';


@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '.toolbar-toggle',
  standalone: false
})
export class ToolbarDirective {

  constructor(
    private readonly el: ElementRef,
    private readonly renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  @HostListener('click')
  onClick() {
    const currentValue = this.el.nativeElement.getAttribute('href');

    // Set focus on '.search-form > input' after a delay
    setTimeout(() => {
      const searchInput = this.document.querySelector('.search-form > input') as HTMLElement;
      if (searchInput) {
        searchInput.focus();
      }
    }, 200);

    if (this.el.nativeElement.classList.contains('active')) {
      this.closeToolBox();
      this.document.querySelectorAll('.toolbar-dropdown').forEach(el => {
        el.classList.remove('open');
      });
    } else {
      if (!this.el.nativeElement.classList.contains('set-settings')) {
        this.document.querySelectorAll('.toolbar-dropdown').forEach(el => {
          el.classList.add('open');
        });

        this.closeToolBox();
        this.el.nativeElement.classList.add('active');
        if (currentValue) {
          const targetElement = this.document.querySelector(currentValue);
          if (targetElement) {
            targetElement.classList.add('current');
          }
        }
        const menuEl = this.document.querySelector('.slideable-menu .menu') as HTMLElement;
        if (menuEl) {
          menuEl.setAttribute('data-height', menuEl.offsetHeight.toString());
        }
      }
    }
  }

  closeToolBox() {
    this.document.querySelectorAll('.toolbar-toggle').forEach(el => {
      el.classList.remove('active');
    });
    this.document.querySelectorAll('.toolbar-section').forEach(el => {
      el.classList.remove('current');
    });
  }

  closeAll() {
    this.closeToolBox();
    this.document.querySelectorAll('.toolbar-dropdown').forEach(el => {
      el.classList.remove('open');
    });
  }

  openLogin() {
    const accountToggle = this.document.querySelector('.account-toggle');
    if (accountToggle && accountToggle.classList.contains('active')) {
      return;
    }
    this.closeToolBox();
    this.document.querySelectorAll('.toolbar-dropdown').forEach(el => {
      el.classList.add('open');
    });
    if (accountToggle) {
      accountToggle.classList.add('active');
    }
    const accountElement = this.document.querySelector('#account');
    if (accountElement) {
      accountElement.classList.add('current');
    }
    const menuEl = this.document.querySelector('.slideable-menu .menu') as HTMLElement;
    if (menuEl) {
      menuEl.setAttribute('data-height', menuEl.offsetHeight.toString());
    }
  }
}
